<script>
    import FilterButton from "./FilterButton.svelte";
    import { createEventDispatcher } from "svelte";
    import { _ } from "svelte-i18n";

    let dispatch = createEventDispatcher();

    export let showsMore = false;

    function onPressed() {
        dispatch("click");
        showsMore = !showsMore;
    }
</script>

<FilterButton
    filter={showsMore ? { name: $_("less") } : { name: $_("more") }}
    on:click={onPressed}
    dense
>
    <div slot="trailing" class="trailing" class:less={!showsMore}>
        {#if showsMore}
            <img src="/images/icons/mini_less.svg" alt={$_("less")} />
        {:else}
            <img src="/images/icons/mini_more.svg" alt={$_("more")} />
        {/if}
    </div>
</FilterButton>

<style>
    .trailing {
        margin-left: 4px;
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
    }

    .less {
        margin-top: 2px;
    }
</style>
